import { deepObjectMerge } from '@/utils/utils.js'
import en from './en'
import v1 from './v1'
import v2 from './v2'
import v6 from './v6'
export default deepObjectMerge(
  en,
  v1,
  v2,
  v6
)



// WEBPACK FOOTER //
// ./src/i18n/languages/en/index.js